import { listSearchSchema } from '@/shared/patterns/list-search';

import { creditNoteFilters } from './credit-note.filters';

/** `validateSearch` da lista (U07): página, tamanho, ordem e os filtros legíveis (P1). Leve, para a rota. */
export const creditNoteListSearch = listSearchSchema({ ...creditNoteFilters.shape });
